<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
    </filter-form>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :indentSize="15" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";
let creditDetailOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  // 接受属性
  props: {
    paramsX: Object
  },
  data() {
    return {
      filter: [
        {
          type: "dateFilter",
          key: "filterTime",
          name: "记账日期"
        },
        {
          type: "select",
          key: "type",
          name: "类型",
          options: creditDetailOptions
        }
      ],
      columns: [
        {
          title: "金蝶单号",
          width: 150,
          dataIndex: "erpNum",
          sorter: true
        },
        {
          title: "记账日期",
          width: 120,
          dataIndex: "occurredTime",
          sorter: true,
          customRender: (text, row, index) => {
            return this.formatDate(row.occurredTime, "YYYY-MM-DD");
          }
        },
        {
          title: "金额",
          width: 150,
          dataIndex: "amount",
          sorter: true
        },
        {
          title: "类型",
          width: 150,
          dataIndex: "type",
          sorter: true,
          customRender: (text, row, index) => {
            return row.typeStr;
          }
        },
        {
          title: "备注",
          dataIndex: "notes"
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { startTime: null, endTime: null, type: null, creditId: 0 },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      creditId: 0
    };
  },
  async mounted() {
    this.getTypeOptions();
    this.creditId = this.paramsX.id;
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.type = p.values.type;
      this.filterdata.startTime =
        p.values.filterTime[0] != null
          ? p.values.filterTime[0].startOf("day").valueOf()
          : null;
      this.filterdata.endTime =
        p.values.filterTime[1] != null
          ? p.values.filterTime[1].startOf("day").valueOf()
          : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async getTypeOptions() {
      creditDetailOptions = [];
      let dictionary = await api.GetDictionaryForSelect({ type: 7 });
      if (dictionary) {
        dictionary.forEach(a => {
          creditDetailOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      options.creditId = this.creditId;
      let data = await api.GetCreditDetailList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Basic/Credit/DetailList.vue